import { render, staticRenderFns } from "./AddNewMember.vue?vue&type=template&id=662a0769"
import script from "./AddNewMember.vue?vue&type=script&lang=js"
export * from "./AddNewMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports